import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { GraduationCap, ShieldCheck } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { AIContent } from "../components/AIContent";
import { T } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SchoolsPage() {
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    axios.get(`${API}/schools`).then((r) => setSchools(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageHero topic="college athletics track students" title="Schools, Colleges & Academies" subtitle="Linking academics and athletics — varsity programs, sports schools, coaching institutes and talent-development centers worldwide." listenTargetId="page-content" />
      <div id="page-content" className="mx-auto max-w-7xl space-y-10 px-4 py-12 sm:px-6">
        <AIContent topic="School and college sport — pathways from playground to podium" context="Editorial on education-based athletics: varsity systems, academies, scholarships and safeguarding for young athletes. No ranking of minors." />
        <div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-5" data-testid="safeguarding-notice">
          <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
          <p className="text-sm text-amber-800"><T>Safeguarding first: SportsPulse minimizes information about minors, never publishes private contact details, and requires institutional authority for youth profiles. Report concerns via our moderation channels.</T></p>
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="schools-grid">
          {schools.map((s) => (
            <Link to={`/schools/${s.id}`} key={s.id} data-testid={`school-card-${s.id}`} className="block rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:border-[#0055FF] hover:shadow-lg">
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#0055FF] text-white"><GraduationCap className="h-5 w-5" /></span>
                <span className="rounded-full bg-blue-50 px-2.5 py-1 text-[10px] font-bold uppercase text-[#0055FF]"><T>{s.type}</T></span>
              </div>
              <h3 className="mt-3 text-lg font-bold text-slate-900">{s.name}</h3>
              <p className="text-xs font-semibold text-slate-400">{s.city}, {s.country}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {s.sports_offered.map((sp) => <span key={sp} className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{sp}</span>)}
              </div>
              <div className="mt-4 space-y-1.5 border-t border-slate-100 pt-3 text-xs text-slate-600">
                <p><span className="font-bold"><T>Association</T>:</span> {s.association}</p>
                <p><span className="font-bold"><T>Notable</T>:</span> <T>{s.notable}</T></p>
              </div>
              <p className="mt-3 text-xs font-bold text-[#0055FF]"><T>View profile</T> →</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
